import { Board } from 'src/bw/board/Board';
import AuthService from '../../services/auth.service';
import NavigationService from '../../services/navigation.service';
import MixpanelService from '../../services/mixpanel.service';
import { FullUserModel, UserUtils } from 'src/types/user.model';
import UserService from 'src/services/user.service';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';
import LogoutService from 'src/services/logout.service';

/** Class for handling creation and usage of test users, for local development */
export default class AuthFactory {
    private readonly component: Board;

    constructor(component: any) {
        this.component = component;
    }

    public async login(): Promise<void> {
        try {
            await AuthService.login();
            await this.afterLoginSetup();
        } catch (e) {
            LogoutService.handleLogoutRedirect();
        }
    }

    /** Helper for running side effects on the response from logging in or signing up */
    public async afterLoginSetup(): Promise<void> {
        if (UserUtils.isBudgetingUser(await UserService.getUser())) {
            NavigationService.goTo(this.component.props.history, BudgetPages.HOME).catch(console.error);
            return;
        }
        await this.component.handleReloadUser(true);
        const user: FullUserModel = this.component.props.user;

        if (user) {
            if (user.attributes.startupStep) {
                // in the middle of NSZ
                this.component.setState({
                    startupStep: user.attributes.startupStep
                });
                await MixpanelService.loginUser(user);
            } else if (Date.parse(user.updated) - Date.parse(user.created) < 60000) {
                // user record just created
                MixpanelService.newUser(user);
                NavigationService.goTo(this.component.props.history, '/', 'Top drawer').catch(console.error);
                if (!this.component.hasData(this.component.props.user)) {
                    // the user just arrived and needs to do onboarding
                    this.component.setState({
                        startupStep: 1,
                        openIntro: false
                    });
                    // await this.component.setOnboardingAttributes();
                }
            } else {
                await MixpanelService.loginUser(user);
            }
        }
        this.component.handleLogin();
        if (this.component.state.signupSuccessCallback) {
            this.component.state.signupSuccessCallback();
            this.component.setState({
                signupSuccessCallback: null
            });
        }
    }
}
